// extracted by mini-css-extract-plugin
export default {"navbar-items":"style_navbar-items__tvMwj"};